import React, { Fragment, useEffect, useState } from 'react';
import Trial from '../Home/Trial';
import Banner from '../Organization/Banner';
import FeaturesOrganization from './FeaturesOrganization';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import Benefits from '../Home/Benefits';
import { useLocale } from '../../localization/LocaleContext';

function OrganizationMain(){
    const { t } = useLocale();

    useEffect(() => {
        document.title = t('meta.organizationTitle')
   }, [t]);

   const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
                <Banner />
                <FeaturesOrganization/>
                <Benefits />
                <Trial/>
                <Footer />
        </Fragment>
    )
}

export default OrganizationMain;